import Vue from 'www/vue_components'
import { VApp } from 'vuetify/lib'
import vuetify from 'www/modules/vuetify-plugin'
import CardList from './CardList.vue'

// eslint-disable-next-line func-names
export default function (card, num, renderBy) {
  return new Vue({
    vuetify,
    components: {
      CardList,
      card,
    },
    render(h) {
      const cardBlocks = h(
        CardList,
        {
          props: {
            cardNum: num,
            renderBy,
          },
        },
        [
          h(card),
        ],
      )

      return h(VApp, [cardBlocks])
    },
  })
}
